import React, { useEffect, useRef, useState } from "react";
import { ArrowDownFilled } from "../../shared/Icons/ArrowDownFilled";
import { Container, IconContainer, Options, SelectedIcon } from "./style";

export interface IOption {
  value: string;
  icon: React.ReactNode;
}

interface IProps {
  options: IOption[];
  selected: any;
  setSelected: React.Dispatch<any>;

  secondaryOptions?: IOption[];
  secondarySelected?: any;
  secondarySetSelected?: React.Dispatch<any>;
}

export const SelectIcons = ({
  options, 
  selected, 
  setSelected, 
  secondaryOptions, 
  secondarySelected, 
  secondarySetSelected
}: IProps) => {
  const [open, setOpen] = useState(false);
  const [lastSelected, setLastSelected] = useState(selected);

  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [containerRef]);

  return (
    <Container ref={containerRef} >
    <SelectedIcon onClick={() => setOpen(!open)}>
      {[...options, ...secondaryOptions ?? []].find( option => lastSelected === option.value)!.icon}
      <ArrowDownFilled className={open ? "opened" : "closed"} />
    </SelectedIcon>
    
    <Options open={open}>
      {options.map( option => (
        <IconContainer 
          key={option.value}
          onClick={() => {setSelected(option.value); setLastSelected(option.value);}} 
          selected={option.value === selected}> 
            { option.icon }
        </IconContainer>
      ))}
      {(secondaryOptions && secondarySetSelected) && secondaryOptions.map( option => (
        <IconContainer 
          key={option.value}
          onClick={() => {secondarySetSelected(option.value); setLastSelected(option.value);}} 
          selected={option.value === secondarySelected}> 
            { option.icon }
        </IconContainer>
      ))}
    </Options>
    </Container>
  );
}